import React, { useState } from "react";
import { Star, X } from "lucide-react";
import { openPlayStoreRating, dismissRateNudge } from "../lib/appFeedback";

// Small inline card that appears on the Dashboard after enough sessions.
export default function RateNudge() {
  const [hidden, setHidden] = useState(false);
  if (hidden) return null;

  const rate = () => {
    openPlayStoreRating();
    dismissRateNudge();
    setHidden(true);
  };
  const later = () => {
    dismissRateNudge();
    setHidden(true);
  };

  return (
    <section
      className="brimi-card p-5 sm:p-6 relative border-brimi-terracotta/30 bg-gradient-to-br from-white to-brimi-terracotta/5"
      data-testid="rate-nudge-card"
    >
      <button
        onClick={later}
        className="absolute top-3 right-3 p-1 text-brimi-navyText/40 hover:text-brimi-navyText"
        aria-label="Dismiss"
        data-testid="rate-nudge-dismiss-btn"
      >
        <X size={18} />
      </button>
      <div className="flex items-start gap-4">
        <div className="w-11 h-11 rounded-2xl bg-brimi-terracotta/15 text-brimi-terracotta grid place-items-center flex-shrink-0">
          <Star size={22} />
        </div>
        <div className="flex-1">
          <p className="font-heading font-semibold text-brimi-navyText">Enjoying BrimiH&G?</p>
          <p className="text-sm text-brimi-navyText/70 mt-1">
            A quick rating on the Play Store helps other ICSE students find us. Takes 20 seconds.
          </p>
          <div className="mt-3 flex flex-wrap gap-2">
            <button onClick={rate} className="brimi-btn-primary" data-testid="rate-nudge-rate-btn">
              <Star size={16} /> Rate on Play Store
            </button>
            <button
              onClick={later}
              className="text-sm font-semibold text-brimi-navyText/60 hover:text-brimi-navyText px-3 py-2"
              data-testid="rate-nudge-later-btn"
            >
              Maybe later
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
